import Popover from './Popover'
import styled from 'styled-components'

export * from './Popover'
export default styled(Popover)``
export { default as PopoverArrow } from './PopoverArrow'
export { default as PopoverContent } from './Content'
